export default __webpack_public_path__ + "static/media/mail.767accf1.png";